import { useDraggableMarker } from '../hooks';
import L from 'leaflet';
import { ReactNode } from 'react';
import { Marker } from 'react-leaflet';

interface DraggableMarkerProps {
    position: [number, number];
    icon?: L.Icon | L.DivIcon;
    onDragEnd?: (lat: number, lng: number) => void;
    children?: ReactNode;
}

/**
 * Компонент для перетягування маркера на карті
 */
export const DraggableMarker = ({
    position,
    icon,
    onDragEnd,
    children
}: DraggableMarkerProps) => {
    const { markerRef, eventHandlers } = useDraggableMarker({
        position,
        onDragEnd
    });

    return (
        <Marker
            draggable={true}
            position={position}
            icon={icon}
            ref={markerRef}
            eventHandlers={eventHandlers}
        >
            {children}
        </Marker>
    );
}; 